import React from 'react';
import { useDispatch } from 'react-redux';
import DTCopyTextSendMacroView from '../DTCopyTextSendMacroView';
import { processRbiRefundAndIssueCoupon } from '../../../../../actions/tools/RBIActions';
import { withConfirmation } from '../../../DTConfirmationView/withConfirmation';

const DTRBIIssueCouponAndRefundThenSendMacroNode = () => {
  const dispatch = useDispatch();

  const handleNextButtonClick = async () => await dispatch(processRbiRefundAndIssueCoupon());

  return (
    <DTCopyTextSendMacroView
      buttonText={'ISSUE COUPON & REFUND'}
      onNextButtonClick={handleNextButtonClick}
      hideCopyText={true}
      popupConfirmationText={'You are about to issue a coupon, process a refund and copy the response to the text box'}
      customErrorMessage={'Refund request or coupon issuing request has failed. Please try again later.'}
    />
  );
};

export default withConfirmation(DTRBIIssueCouponAndRefundThenSendMacroNode);
